<!--  -->
<template>
  <div class="cen">
    <dl class="navigation">
      <div class="dddiv">
        <div class="dd">1<span>户籍信息</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd">2<span>户籍附件</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd li_special">3<span>房产信息</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd">4<span>学校信息</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd">5<span>提交信息</span></div>
      </div>
    </dl>
    <van-form @submit="next" @failed="onFailed" ref="forms">
      <!-- 房屋所有权人 -->
      <van-field
        required
        v-model="ruleForm3.name"
        name="房屋所有权人"
        label="房屋所有权人"
        placeholder="请输入"
        input-align="right"
        :rules="rules.name"
      />
      <!-- 房屋所有权人身份证号 -->
      <van-field
        required
        v-model="ruleForm3.idno"
        name="房屋所有权人身份证号"
        label="房屋所有权人身份证号"
        placeholder="请输入"
        input-align="right"
        :rules="rules.idno"
        @blur="getInfo1(ruleForm3.idno)"
      />
      <!-- 房屋所有人关系 -->
      <van-field
        required
        readonly
        clickable
        name="学生与房屋所有人关系"
        :value="ruleForm3.relationship"
        label="学生与房屋所有人关系"
        placeholder="请先输入房屋所有权人身份证再选择"
        @click="tshow1 = true"
        :rules="rules.relationship"
        input-align="right"
        right-icon="arrow"
        :disabled="ruleForm3.idno == ''"
      />
      <van-popup v-model="tshow1" position="bottom">
        <van-picker
          show-toolbar
          :columns="relationships"
          value-key="label"
          @confirm="onConfirm1"
          @cancel="tshow1 = false"
        />
      </van-popup>
      <!-- 是否与祖辈在同一户籍  -->
      <van-field
        required
        v-if="ruleForm3.relationshipid == 4"
        name="是否与祖辈在同一户籍 "
        label="是否与祖辈在同一户籍 "
        input-align="right"
        :rules="rules.iszbtyhj"
      >
        <template #input>
          <van-radio-group v-model="ruleForm3.iszbtyhj" direction="horizontal">
            <van-radio name="0">是</van-radio>
            <van-radio name="1">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!-- 房产登记时间 -->
      <van-field
        required
        name="房产登记时间"
        label="房产登记时间"
        input-align="right"
        :value="ruleForm3.djtime"
        :rules="rules.djtime"
        @click="tshow2 = true"
        readonly
        clickable
        placeholder="请选择房产登记时间"
        right-icon="arrow"
      >
      </van-field>
      <van-calendar
        v-model="tshow2"
        :max-date="maxDate"
        :min-date="minDate"
        @confirm="onConfirm2"
      />
      <!-- 房屋坐落 -->
      <van-field
        required
        v-model="ruleForm3.address"
        name="房屋坐落"
        label="房屋坐落"
        placeholder="请输入"
        input-align="right"
        :rules="rules.address"
      />
      <!-- 房屋具体位置 -->
      <van-field
        required
        v-model="ruleForm3.address1"
        name="房屋具体位置"
        label="房屋具体位置"
        placeholder="请输入"
        input-align="right"
        :rules="rules.address1"
      />
      <!-- 房产类型 -->
      <van-field
        required
        readonly
        clickable
        name="房产类型"
        :value="ruleForm3.type"
        label="房产类型"
        placeholder="请选择房产类型"
        @click="tshow3 = true"
        :rules="rules.type"
        input-align="right"
        right-icon="arrow"
      />
      <van-popup v-model="tshow3" position="bottom">
        <van-picker
          show-toolbar
          :columns="tlist"
          value-key="label"
          @confirm="onConfirm3"
          @cancel="tshow3 = false"
        />
      </van-popup>
      <!-- A房产编号 -->
      <van-field
        required
        v-if="ruleForm3.typeid == 'A'"
        v-model="ruleForm3.fcid1"
        name="房产编号"
        label="房产编号"
        placeholder="请输入"
        input-align="right"
        :rules="rules.fcid1"
        class="fcbh"
      >
        <template #input>
          <span>梅 房权证 梅河口市 字第</span>
          <input
            type="text"
            placeholder="请输入"
            v-model="ruleForm3.fcid1"
            class="duan"
          />
          <span>号</span>
        </template>
      </van-field>
      <!-- B房产编号 -->
      <van-field
        required
        v-if="ruleForm3.typeid == 'B'"
        v-model="ruleForm3.fcid2"
        name="房产编号"
        label="房产编号"
        placeholder="请输入"
        input-align="right"
        :rules="rules.fcid2"
        class="fcbh"
      >
        <template #input>
          <span>吉(</span>
          <input
            type="text"
            placeholder="请输入"
            v-model="ruleForm3.fcid1"
            class="duan"
          />
          <span>)梅河口市 不动产权第</span>
          <input
            type="text"
            placeholder="请输入"
            v-model="ruleForm3.fcid2"
            class="duan"
          />
          <span>号</span>
        </template>
      </van-field>
      <!-- C  -->
      <!-- 发票金额 -->
      <van-field
        required
        v-if="ruleForm3.typeid == 'C'"
        v-model="ruleForm3.Invoicemoney"
        name="发票金额"
        label="发票金额"
        placeholder="请输入"
        input-align="right"
        :rules="rules.Invoicemoney"
      />
      <!-- 合同签订时间 -->
      <van-field
        required
        v-if="ruleForm3.typeid == 'C'"
        name="合同签订时间"
        label="合同签订时间"
        input-align="right"
        :value="ruleForm3.htqdtime"
        :rules="rules.htqdtime"
        @click="tshow4 = true"
        readonly
        clickable
        placeholder="请选择合同签订时间"
        right-icon="arrow"
      >
      </van-field>
      <van-calendar
        v-model="tshow4"
        :max-date="maxDate"
        :min-date="minDate"
        @confirm="onConfirm4"
      />
      <!-- 发票代码 -->
      <van-field
        v-if="ruleForm3.typeid == 'C'"
        v-model="ruleForm3.Invoicedm"
        name="发票代码"
        label="发票代码"
        placeholder="请输入"
        input-align="right"
        :rules="rules.Invoicedm"
      />
      <!-- 发票号码 -->
      <van-field
        v-if="ruleForm3.typeid == 'C'"
        v-model="ruleForm3.Invoicehm"
        name="发票号码"
        label="发票号码"
        placeholder="请输入"
        input-align="right"
        :rules="rules.Invoicehm"
      />
      <!-- D E -->
      <!-- 产权人 -->
      <van-field
        required
        v-if="ruleForm3.typeid == 'D' || ruleForm3.typeid == 'E'"
        v-model="ruleForm3.cqname"
        name="产权人"
        label="产权人"
        placeholder="请输入"
        input-align="right"
        :rules="rules.cqname"
      />
      <!-- 签订时间-->
      <van-field
        required
        v-if="ruleForm3.typeid == 'D' || ruleForm3.typeid == 'E'"
        name="签订时间"
        label="签订时间"
        input-align="right"
        :value="ruleForm3.qdtime"
        :rules="rules.qdtime"
        @click="tshow5 = true"
        readonly
        clickable
        placeholder="请选择签订时间"
        right-icon="arrow"
      >
      </van-field>
      <van-calendar
        v-model="tshow5"
        :max-date="maxDate"
        :min-date="minDate"
        @confirm="onConfirm5"
      />
      <!-- 协议书编号 -->
      <van-field
        v-if="ruleForm3.typeid == 'D' || ruleForm3.typeid == 'E'"
        v-model="ruleForm3.xqsid"
        name="协议书编号"
        label="协议书编号"
        placeholder="请输入"
        input-align="right"
        :rules="rules.xqsid"
      />
      <!-- 差额票据 -->
      <van-field
        v-if="ruleForm3.typeid == 'D' || ruleForm3.typeid == 'E'"
        v-model="ruleForm3.bill"
        name="差额票据"
        label="差额票据"
        placeholder="请输入"
        input-align="right"
        :rules="rules.bill"
      />
      <!-- F1 F2 G1 G2 -->
      <!-- 协议签订时间-->
      <van-field
        required
        v-if="
          ruleForm3.typeid == 'F1' ||
          ruleForm3.typeid == 'F2' ||
          ruleForm3.typeid == 'G1' ||
          ruleForm3.typeid == 'G2'
        "
        name="协议签订时间"
        label="协议签订时间"
        input-align="right"
        :value="ruleForm3.xyqdtime"
        :rules="rules.xyqdtime"
        @click="tshow6 = true"
        readonly
        clickable
        placeholder="请选择签订时间"
        right-icon="arrow"
      >
      </van-field>
      <van-calendar
        v-model="tshow6"
        :max-date="maxDate"
        :min-date="minDate"
        @confirm="onConfirm6"
      />
      <!-- 房产类型证明-->
      <van-field
        required
        class="tupian"
        name="uploader"
        label="房产类型证明"
        :rules="rules.htimg"
      >
        <template #input>
          <span class="imgts">(请上传所选房产类型对应的证明)</span>
          <van-uploader
            v-model="imgstaus.fileList"
            name="1"
            :max-count="1"
            :after-read="upimg"
            @delete="delimg"
          />
          <span class="red">多页材料请拼图后上传</span>
        </template>
      </van-field>
      <!-- 提交按钮 -->
      <div style="margin: 0.64rem; margin-top: 2rem">
        <van-button class="btn" native-type="button" @click="back"
          >返回</van-button
        >
        <van-button class="btn" :loading="codeDisabled" native-type="submit"
          >保存并下一步</van-button
        >
      </div>
      <div class="bgdiv"></div>
    </van-form>
    <notices></notices>
  </div>
</template>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapGetters } from "vuex";
import "element-ui/lib/theme-chalk/index.css";
import rules from "@/utils/rules";
import { savethree, upimg, selectthree, selectone } from "@/api/news";
import sessionUtils from "@/utils/session-store-utils";
import notices from "../components/notices.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { notices },
  data() {
    //这里存放数据
    // 自定义验证
    let validate = (rule, value, callback) => {
      //验证器
      if (this.ruleForm3.fcid1 == "") {
        return false;
      } else if (this.ruleForm3.fcid2 == "") {
        return false;
      } else {
        return true;
      }
    };
    // 自定义验证
    let validimg = (rule, value, callback) => {
      //验证器
      // console.log(rule, value);
      if (rule[0].status == "failed" || rule[0].status == "uploading") {
        //为true代表图片在  false报错
        return false;
      } else {
        return true;
      }
    };
    return {
      firstget: "0",
      tshow1: false, //房屋所有人关系
      tshow2: false, //房屋登记日期
      tshow3: false, //房屋类型
      tshow4: false, //合同签订时间
      tshow5: false, //签订时间
      tshow6: false, //协议签订时间
      maxDate: new Date(), //最大日期
      minDate: new Date(1960, 0, 31), //最大日期
      codeDisabled: false,
      loading: false,
      loading1: false,
      cha1: 0,
      cha2: 0,
      fileUpload: process.env.VUE_APP_FILE_UPLOAD_URL, //上传地址
      imgstaus: {
        upimg: false,
        fileList: [],
      },
      ruleForm1: {}, //判断显示附件的对象
      fileList1: [], //上传合集
      tlist: [
        // { label: "房屋所有权证", value: "A" },
        // { label: "不动产权证书", value: "B" },
        // { label: "商品房买卖合同", value: "C" },
        // { label: "产权调换协议书", value: "D" },
        // { label: "货币化安置合同", value: "E" },
        // { label: "廉租房", value: "F1" },
        // { label: "住房补贴", value: "F2" },
        // { label: "租房", value: "G1" },
        // { label: "二手房未过户", value: "G2" },
      ],
      tlist1: [
        // 类型数组
        { label: "房屋所有权证", value: "A" },
        { label: "不动产权证书", value: "B" },
        { label: "商品房买卖合同", value: "C" },
        { label: "产权调换协议书", value: "D" },
        { label: "货币化安置合同", value: "E" },
        { label: "廉租房", value: "F1" },
        { label: "住房补贴", value: "F2" },
      ],
      tlist2: [
        // 类型数组
        { label: "租房", value: "G1" },
        { label: "二手房未过户", value: "G2" },
        { label: "其他", value: "H" },
      ],
      ruleForm3: {
        type: "", //类型 A.房屋所有权证 B.不动产权证书 C.商品房买卖合同 D.产权调换协议书 E.货币化安置合同 F.廉租房和住房补贴 G.租房户和二手房未过户
        name: "", //房屋所有权人
        relationship: "", //与学生关系
        relationshipid: "", //与学生关系id
        iszbtyhj: "", //是否与祖辈在同一户籍
        idno: "", //房屋所有权人身份证号
        djtime: "", //房产登记时间
        address: "", //房屋坐落（按房产证填写）
        address1: "", //房屋具体位置
        fcid: "", //房产编号
        fcid1: "", //房产编号1
        fcid2: "", //房产编号2
        Invoicemoney: "", //发票金额
        Invoicedm: "", //发票代码
        Invoicehm: "", //发票号码
        htqdtime: "", //合同签订时间
        cqname: "", //产权人
        qdtime: "", //签订时间
        xqsid: "", //协议书编号
        bill: "", //差额票据
        xyqdtime: "", //协议签订时间
        htimg: "", //合同证书
      },
      relationships: [
        { label: "本人", value: "6" },
        { label: "父子", value: "0" },
        { label: "母子", value: "1" },
        { label: "父女", value: "2" },
        { label: "母女", value: "3" },
        { label: "祖孙", value: "4" },
        { label: "其他", value: "5" },
      ],
      relationships0: [
        { label: "本人", value: "6" },
        { label: "父子", value: "0" },
        { label: "母子", value: "1" },
        { label: "祖孙", value: "4" },
        { label: "其他", value: "5" },
      ],
      relationships1: [
        { label: "本人", value: "6" },
        { label: "父女", value: "2" },
        { label: "母女", value: "3" },
        { label: "祖孙", value: "4" },
        { label: "其他", value: "5" },
      ],
      relationships2: [
        { label: "本人", value: "6" },
        { label: "父子", value: "0" },
        { label: "祖孙", value: "4" },
        { label: "其他", value: "5" },
      ],
      relationships3: [
        { label: "本人", value: "6" },
        { label: "母子", value: "1" },
        { label: "祖孙", value: "4" },
        { label: "其他", value: "5" },
      ],
      relationships4: [
        { label: "本人", value: "6" },
        { label: "父女", value: "2" },
        { label: "祖孙", value: "4" },
        { label: "其他", value: "5" },
      ],
      relationships5: [
        { label: "本人", value: "6" },
        { label: "母女", value: "3" },
        { label: "祖孙", value: "4" },
        { label: "其他", value: "5" },
      ],
      relationship: [
        { label: "父子", value: "0" },
        { label: "母子", value: "1" },
        { label: "父女", value: "2" },
        { label: "母女", value: "3" },
        { label: "其他", value: "4" },
      ],
      rules: {
        name: [
          {
            required: true,
            message: "请输入房屋所有权人姓名",
            trigger: "blur",
          },
          { pattern: /^[\u4E00-\u9FA5]+$/, message: "姓名只能为中文" },
        ],
        relationship: [
          {
            required: true,
            message: "请选择学生与房屋所有人关系",
            trigger: "blur",
          },
        ],
        idno: [
          {
            required: true,
            message: "请输入房屋所有权人身份证号",
            trigger: "blur",
          },
          {
            required: true,
            message: "身份证号填写不合法",
            trigger: "blur",
            pattern:
              /^(([1-9][0-9]{5}(19|20)[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}([0-9]|X|x))|([1-9][0-9]{5}[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}))$/,
          },
        ],
        djtime: [
          { required: true, message: "请选择房产登记时间", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入房屋坐落", trigger: "blur" },
        ],
        address1: [
          { required: true, message: "请输入房屋具体位置", trigger: "blur" },
        ],
        type: [{ required: true, message: "请选择房产类型", trigger: "blur" }],
        iszbtyhj: [
          {
            required: true,
            message: "请选择是否与祖辈在同一户籍",
            trigger: "blur",
          },
        ],
        fcid1: [{ required: true, message: "请输入房产编号", trigger: "blur" }],
        fcid2: [
          { message: "请输入房产编号", validator: validate, trigger: "blur" },
        ],
        Invoicemoney: [
          { required: true, message: "请输入发票金额", trigger: "blur" },
        ],
        // Invoicedm: [
        //   { required: true, message: "请输入发票代码", trigger: "blur" },
        // ],
        // Invoicehm: [
        //   { required: true, message: "请输入发票号码", trigger: "blur" },
        // ],
        htqdtime: [
          { required: true, message: "请选择合同签订时间", trigger: "blur" },
        ],
        cqname: [{ required: true, message: "请输入产权人", trigger: "blur" }],
        qdtime: [
          { required: true, message: "请选择签订时间", trigger: "blur" },
        ],
        // xqsid: [
        //   { required: true, message: "请输入协议书编号", trigger: "blur" },
        // ],
        // bill: [{ required: true, message: "请输入差额票据", trigger: "blur" }],
        xyqdtime: [
          { required: true, message: "请选择协议签订时间", trigger: "blur" },
        ],
        htimg: [
          {
            required: true,
            message: "请上传所选房产类型对应的证明",
            trigger: "blur",
            validator: validimg,
          },
        ],
      },
      tjpan: 0,
      dialogImageUrl: "",
      dialogVisible: false,
      setDisabled: {
        disabledDate(time) {
          return time.getTime() > Date.now(); // 可选历史天、可选当前天、不可选未来天
        },
      },
    };
  },
  //监听属性 类似于data概念
  computed: {
    ...mapGetters(["leftBtnClick", "rightBtnClick"]),
  },
  //监控data中的数据变化
  watch: {
    leftBtnClick(clickdic) {
      console.log(clickdic);
      this.$router.push({
        path: "/p-r-upload",
      });
    },
    rightBtnClick(clickdic) {
      // console.log(clickdic);
      sessionStorage.setItem("from", JSON.stringify(this.from));
      this.$router.push({
        path: "/record",
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.loading = true;
    this.getyear();
    this.pan();
  },
  methods: {
    onFailed(failed) {
      console.log(failed);
      const errors = failed.errors;
      this.$refs.forms.scrollToField(errors[0].name, false);
    },
    getyear() {
      const year = new Date().getFullYear();
      // this.minDate = new Date(year - 10, 0, 31);
      // this.maxDate = new Date(year + 10, 0, 31);
    },
    //学生与落户籍人关系弹窗
    onConfirm1(s) {
      console.log(s);
      this.tshow1 = false;
      this.ruleForm3.relationship = s.label;
      this.ruleForm3.relationshipid = s.value;
    },
    //房产登记日期
    onConfirm2(s) {
      console.log(s);
      this.tshow2 = false;
      this.ruleForm3.djtime = this.timeFormat(s);
      console.log(this.ruleForm3.type);
      if (this.ruleForm3.typeid == "C") {
        console.log(123);
        this.ruleForm3.htqdtime = this.timeFormat(s);
      }
    },
    //房产类型
    onConfirm3(s) {
      console.log(s);
      this.tshow3 = false;
      this.ruleForm3.type = s.label;
      this.ruleForm3.typeid = s.value;
      this.ruleForm3.djtime = ""; //房产登记时间
      this.ruleForm3.fcid1 = ""; //房产编号1
      this.ruleForm3.fcid2 = ""; //房产编号2
      this.ruleForm3.Invoicemoney = ""; //发票金额
      this.ruleForm3.Invoicedm = ""; //发票代码
      this.ruleForm3.Invoicehm = ""; //发票号码
      this.ruleForm3.htqdtime = ""; //合同签订时间
      this.ruleForm3.cqname = ""; //产权人
      this.ruleForm3.qdtime = ""; //签订时间
      this.ruleForm3.xqsid = ""; //协议书编号
      this.ruleForm3.bill = ""; //差额票据
      this.ruleForm3.xyqdtime = ""; //协议签订时间
      this.ruleForm3.htimg = ""; //房产类型证明
      this.imgstaus.fileList = []; //图片集合

      // this.$refs.ruleForm3.clearValidate("fcid1");
      // this.$refs.ruleForm3.clearValidate("fcid2");
      // this.$refs.ruleForm3.clearValidate("Invoicemoney");
      // this.$refs.ruleForm3.clearValidate("htqdtime");
      // this.$refs.ruleForm3.clearValidate("cqname");
      // this.$refs.ruleForm3.clearValidate("qdtime");
      // this.$refs.ruleForm3.clearValidate("xyqdtime");
    },
    //合同签订日期
    onConfirm4(s) {
      console.log(s);
      this.tshow4 = false;
      this.ruleForm3.htqdtime = this.timeFormat(s);
      if (this.ruleForm3.typeid == "C") {
        this.ruleForm3.djtime = this.timeFormat(s);
      }
    },
    //签订日期
    onConfirm5(s) {
      console.log(s);
      this.tshow5 = false;
      this.ruleForm3.qdtime = this.timeFormat(s);
    },
    //协议签订时间
    onConfirm6(s) {
      console.log(s);
      this.tshow6 = false;
      this.ruleForm3.xyqdtime = this.timeFormat(s);
    },
    //时间戳转换
    timeFormat(timestamp) {
      var time = new Date(timestamp);
      var y = time.getFullYear(); //getFullYear方法以四位数字返回年份
      var m = time.getMonth() + 1; // getMonth方法从 Date 对象返回月份 (0 ~ 11)，返回结果需要手动加一
      var d = time.getDate(); // getDate方法从 Date 对象返回一个月中的某一天 (1 ~ 31)
      function timeAdd(m) {
        return m < 10 ? "0" + m : m;
      }
      var timeStr = y + "-" + timeAdd(m) + "-" + timeAdd(d);
      return timeStr;
    },
    //用户须知公共弹窗
    tan() {
      this.$notice(true);
    },
    //判断显示那些附件
    pan() {
      if (JSON.parse(sessionStorage.getItem("from1"))) {
        this.ruleForm1 = JSON.parse(sessionStorage.getItem("from1"));
        if (this.ruleForm1.isfc == "0") {
          this.tlist = this.tlist1;
        } else {
          this.tlist = this.tlist2;
        }
        this.cha1 = 1;
        if (this.cha1 == "1" && this.cha2 == "1") {
          this.loading = false;
        }
        this.relationships =
          this.ruleForm1.gender == "0"
            ? this.relationships0
            : this.relationships1;
        this.setsession();
      } else {
        this.selectone();
      }
    },
    //读取本地存储
    setsession() {
      if (JSON.parse(sessionStorage.getItem("from3"))) {
        const s = JSON.parse(sessionStorage.getItem("from3"));
        const ss = JSON.parse(sessionStorage.getItem("fcimgstaus"));
        this.ruleForm3 = s;
        this.imgstaus = ss;
        this.cha2 = 1;
        if (this.cha1 == "1" && this.cha2 == "1") {
          this.loading = false;
        }
        if (this.ruleForm1.isfc == "0") {
          if (
            this.ruleForm3.typeid == "G1" ||
            this.ruleForm3.typeid == "G2" ||
            this.ruleForm3.typeid == "H"
          ) {
            this.ruleForm3.type = "";
            this.ruleForm3.typeid = "";
            this.ruleForm3.htimg = "";
            this.imgstaus.fileList = [];
            this.imgstaus.upimg = false;
          }
        } else if (this.ruleForm1.isfc == "2") {
          if (
            this.ruleForm3.typeid != "G1" &&
            this.ruleForm3.typeid != "G2" &&
            this.ruleForm3.typeid != "H"
          ) {
            this.ruleForm3.type = "";
            this.ruleForm3.typeid = "";
            this.ruleForm3.htimg = "";
            this.imgstaus.fileList = [];
            this.imgstaus.upimg = false;
          }
        }
        this.getInfo1(this.ruleForm3.idno, 1);
      } else {
        this.selectthree();
      }
    },
    //选择房产类型
    xuanze() {
      this.ruleForm3.fcid1 = ""; //房产编号1
      this.ruleForm3.fcid2 = ""; //房产编号2
      this.ruleForm3.Invoicemoney = ""; //发票金额
      this.ruleForm3.Invoicedm = ""; //发票代码
      this.ruleForm3.Invoicehm = ""; //发票号码
      this.ruleForm3.htqdtime = ""; //合同签订时间
      this.ruleForm3.cqname = ""; //产权人
      this.ruleForm3.qdtime = ""; //签订时间
      this.ruleForm3.xqsid = ""; //协议书编号
      this.ruleForm3.bill = ""; //差额票据
      this.ruleForm3.xyqdtime = ""; //协议签订时间
      this.ruleForm3.htimg = ""; //房产类型证明
      this.imgstaus.fileList = []; //图片集合
      console.log(this.ruleForm3.htimg);
      this.$refs.ruleForm3.clearValidate("fcid1");
      this.$refs.ruleForm3.clearValidate("fcid2");
      this.$refs.ruleForm3.clearValidate("Invoicemoney");
      this.$refs.ruleForm3.clearValidate("htqdtime");
      this.$refs.ruleForm3.clearValidate("cqname");
      this.$refs.ruleForm3.clearValidate("qdtime");
      this.$refs.ruleForm3.clearValidate("xyqdtime");
    },
    //上传图片接口
    async upimg(file) {
      console.log(file);
      console.log(this.imgstaus);
      this.imgstaus.fileList[0].status = "uploading";
      this.imgstaus.fileList[0].message = "上传中...";
      console.log("原始图片" + file.file.size / 1024 + "KB");
      let form = new FormData();
      let imgFile;
      if (file.file.size / 1024 > 2048) {
        imgFile = await this.blobToBase64(file.file, file.file.name);
        console.log(imgFile);
        console.log("压缩之后图片" + imgFile.size / 1024 + "KB");
        form.append("file", imgFile);
      } else {
        form.append("file", file.file);
      }
      const res = await upimg(form);
      console.log(res);
      this.loading1 = false;
      if (res.code == "200") {
        let ss = res;
        ss.url = process.env.VUE_APP_FILE_UPLOAD_URL + ss.url;
        this.ruleForm3.htimg = res.fileName;
        this.imgstaus.fileList[0].status = "success";
        this.imgstaus.fileList[0].file = form;
      } else {
        this.imgstaus.fileList[0].status = "failed";
        this.imgstaus.fileList[0].message = "上传失败";
        // this["upimg" + s] = false;
        // this["fileList" + s] = [];
        this.$toast("上传失败," + res.msg);
      }
    },
    //file转base64
    async blobToBase64(blob, s) {
      const self = await this; // 绑定this
      const reader = await new FileReader(); // 实例化一个reader文件
      await reader.readAsDataURL(blob); // 添加二进制文件
      return new Promise(function (resolve, reject) {
        reader.onload = async function (event) {
          const base64 = await event.target.result; // 获取到它的base64文件
          const scale = 0.92; // 设置缩放比例 （0-1）
          let file = await self.compressImg(base64, scale, s);
          resolve(file);
        };
      });
    },
    //压缩
    async compressImg(base64, scale, s) {
      console.log(`开始缩放，scale=${scale}`);
      // 处理缩放，转换格式
      // 用canvas来压缩
      const img = new Image();
      img.src = base64;
      const self = this;
      return new Promise(function (resolve, reject) {
        img.onload = async function () {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.setAttribute("width", this.width);
          canvas.setAttribute("height", this.height);
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          // 转成base64 文件
          base64 = canvas.toDataURL("image/jpeg", 0.5);
          self.imgstaus.fileList[0].content = base64;
          const arr = base64.split(",");
          const mime = arr[0].match(/:(.*?);/)[1];
          const bytes = atob(arr[1]);
          const bytesLength = bytes.length;
          const u8arr = new Uint8Array(bytesLength);
          for (let i = 0; i < bytes.length; i++) {
            u8arr[i] = bytes.charCodeAt(i);
          }
          const file = await new File([u8arr], s, { type: mime });
          resolve(file);
        };
      });
    },
    //删除图片
    delimg(file, name) {
      console.log(file);
      console.log(name);
      this.ruleForm3.htimg = "";
    },
    back() {
      this.$router.push({
        path: "/p-r-upload",
        query: {
          // backId: this.backId === undefined ? this.ruleForm3.id : this.backId,
        },
      });
    },
    next() {
      const a = JSON.parse(sessionStorage.getItem("threeid"));
      if (
        (a === "undefined" || a == null || a === "") &&
        this.firstget == "0"
      ) {
        this.selectthree1();
      } else {
        if (this.tjpan == 0) {
          this.submit();
        }
      }
    },
    //保存
    async submit() {
      this.codeDisabled = true;
      this.tjpan = 1;
      if (this.ruleForm3.typeid == "A") {
        this.ruleForm3.fcid =
          "梅 房权证 梅河口市 字第" + this.ruleForm3.fcid1 + "号";
      } else if (this.ruleForm3.typeid == "B") {
        this.ruleForm3.fcid =
          "吉（" +
          this.ruleForm3.fcid1 +
          "）梅河口市 不动产权第" +
          this.ruleForm3.fcid2 +
          "号";
      }
      const res = await savethree({
        id: JSON.parse(sessionStorage.getItem("threeid")), //主键id
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //用户报名id
        propertyOwnerName: this.ruleForm3.name, //	房屋所有人姓名
        propertyOwnerRelation: this.ruleForm3.relationshipid, //房屋所有人关系
        sfyzbztyhj: this.ruleForm3.iszbtyhj, //是否与祖辈是同一户籍
        propertyOwnerIdcard: this.ruleForm3.idno, //房屋所有人身份证号
        realEstateRegTime: this.ruleForm3.djtime, //房产登记时间
        hourseLocalcation: this.ruleForm3.address, //	房屋坐落
        hourseAddress: this.ruleForm3.address1, //房屋具体位置
        hourseType: this.ruleForm3.typeid, //房产类型
        hourseNumber: this.ruleForm3.fcid, //房产编号1
        // hourseNumberOne: this.ruleForm3.fcid1, //房产编号1
        // hourseNumberTwo: this.ruleForm3.fcid2, //房产编号2
        invoiceAmount: this.ruleForm3.Invoicemoney, //	发票金额
        contractSignTime: this.ruleForm3.htqdtime, //合同签订时间
        invoiceCode: this.ruleForm3.Invoicedm, //发票代码
        invoiceNumber: this.ruleForm3.Invoicehm, //发票号码
        propertyOwner: this.ruleForm3.cqname, //产权人
        signTime: this.ruleForm3.qdtime, //签订时间
        agreementNumber: this.ruleForm3.xqsid, //协议书编号
        differentialBill: this.ruleForm3.bill, //差额票据
        agreementSignTime: this.ruleForm3.xyqdtime, //协议签订时间
        housingOwnershipPath: this.ruleForm3.htimg, //房屋所有权证
      });
      this.tjpan = 0;
      this.codeDisabled = false;
      if (res.code == "200") {
        this.$toast("保存成功");
        console.log(this.imgstaus);
        sessionStorage.setItem("from3", JSON.stringify(this.ruleForm3));
        sessionStorage.setItem("fcimgstaus", JSON.stringify(this.imgstaus));
        sessionStorage.setItem("threeid", JSON.stringify(res.data.id));
        this.$router.push({
          path: "/school",
          // query: { typeId: this.typeId, householdId: this.householdId },
        });
      } else {
        this.$toast("提交失败，" + res.msg);
      }
    },
    //查询返显
    async selectthree() {
      this.$toast.loading();
      const res = await selectthree({
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //报名id
      });
      console.log(res);
      this.$toast.clear();
      this.cha2 = 1;
      if (this.cha1 == "1" && this.cha2 == "1") {
        this.loading = false;
      }
      if (res.code == "200") {
        const s = res.data;
        this.ruleForm3.typeid = s.hourseType; //类型 A.房屋所有权证 B.不动产权证书 C.商品房买卖合同 D.产权调换协议书 E.货币化安置合同 F.廉租房和住房补贴 G.租房户和二手房未过户
        this.ruleForm3.name = s.propertyOwnerName; //房屋所有权人
        this.ruleForm3.relationshipid = s.propertyOwnerRelation; //与学生关系
        this.ruleForm3.iszbtyhj = s.sfyzbztyhj; //与祖辈是否在同一户籍
        this.ruleForm3.idno = s.propertyOwnerIdcard; //房屋所有权人身份证号
        this.ruleForm3.djtime = s.realEstateRegTime; //房产登记时间
        this.ruleForm3.address = s.hourseLocalcation; //房屋坐落（按房产证填写）
        this.ruleForm3.address1 = s.hourseAddress; //房屋具体位置
        this.ruleForm3.fcid = s.hourseNumber; //房产编号
        this.ruleForm3.Invoicemoney = s.invoiceAmount; //发票金额
        this.ruleForm3.Invoicedm = s.invoiceCode; //发票代码
        this.ruleForm3.Invoicehm = s.invoiceNumber; //发票号码
        this.ruleForm3.htqdtime = s.contractSignTime; //合同签订时间
        this.ruleForm3.cqname = s.propertyOwner; //产权人
        this.ruleForm3.qdtime = s.signTime; //签订时间
        this.ruleForm3.xqsid = s.agreementNumber; //协议书编号
        this.ruleForm3.bill = s.differentialBill; //差额票据
        this.ruleForm3.xyqdtime = s.agreementSignTime; //协议签订时间
        this.ruleForm3.htimg = s.housingOwnershipPath; //合同证书
        this.imgstaus.fileList.push({
          url: process.env.VUE_APP_FILE_UPLOAD_URL + this.ruleForm3.htimg,
          s: 1,
        });
        this.imgstaus.upimg = true;
        if (this.ruleForm1.isfc == "0") {
          if (
            this.ruleForm3.typeid == "G1" ||
            this.ruleForm3.typeid == "G2" ||
            this.ruleForm3.typeid == "H"
          ) {
            this.ruleForm3.type = "";
            this.ruleForm3.typeid = "";
            this.ruleForm3.htimg = "";
            this.imgstaus.fileList = [];
            this.imgstaus.upimg = false;
          }
        } else if (this.ruleForm1.isfc == "2") {
          if (
            this.ruleForm3.typeid != "G1" &&
            this.ruleForm3.typeid != "G2" &&
            this.ruleForm3.typeid != "H"
          ) {
            this.ruleForm3.type = "";
            this.ruleForm3.typeid = "";
            this.ruleForm3.htimg = "";
            this.imgstaus.fileList = [];
            this.imgstaus.upimg = false;
          }
        }
        if (this.ruleForm3.typeid == "A") {
          const str = this.ruleForm3.fcid;
          const indexs = str.indexOf("第");
          const str1 = str.substring(indexs + 1, str.length);
          const index = str1.indexOf("号");
          const resolve = str1.substring(0, index);
          console.log(resolve);
          this.ruleForm3.fcid1 = resolve;
        } else if (this.ruleForm3.typeid == "B") {
          const a = this.ruleForm3.fcid;
          const i = a.indexOf("（");
          const b = a.substring(i + 1, a.length);
          const i1 = b.indexOf("）");
          const resolve = b.substring(0, i1);
          console.log(resolve);
          this.ruleForm3.fcid1 = resolve;
          const i2 = a.indexOf("第");
          const c = a.substring(i2 + 1, a.length);
          const i3 = c.indexOf("号");
          const resolve1 = c.substring(0, i3);
          console.log(resolve1);
          this.ruleForm3.fcid2 = resolve1;
        }
        this.relationships.forEach((e) => {
          if (e.value == this.ruleForm3.relationshipid) {
            this.ruleForm3.relationship = e.label;
          }
        });
        console.log(this.tlist);
        this.tlist.forEach((e) => {
          if (e.value == this.ruleForm3.typeid) {
            this.ruleForm3.type = e.label;
            console.log("房产类型赋值" + this.ruleForm3.type);
          }
        });
        sessionStorage.setItem("from3", JSON.stringify(this.ruleForm3));
        sessionStorage.setItem("fcimgstaus", JSON.stringify(this.imgstaus));
        sessionStorage.setItem("threeid", JSON.stringify(res.data.id));
        this.getInfo1(this.ruleForm3.idno, 1);
      } else {
        this.$toast("查询失败," + res.msg);
      }
    },
    //查询返显1
    async selectthree1() {
      this.$toast.loading();
      const res = await selectthree({
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //报名id
      });
      console.log(res);
      this.$toast.clear();
      if (res.code == "200") {
        if (res.data) {
          sessionStorage.setItem("threeid", JSON.stringify(res.data.id));
          this.next();
        } else {
          this.firstget = "1";
          this.next();
        }
      } else {
        this.$toast("查询失败," + res.msg);
      }
    },
    //查询返显one
    async selectone() {
      const res = await selectone({
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //报名id
      });
      console.log(res);
      this.cha1 = 1;
      if (this.cha1 == "1" && this.cha2 == "1") {
        this.loading = false;
      }
      if (res.code == "200") {
        const s = res.data;
        this.ruleForm1.name = s.studentName; //学生姓名
        this.ruleForm1.idCard = s.studentIdcard; //学生身份证号
        this.ruleForm1.gender = s.studentGender; //学生性别
        this.ruleForm1.nation = s.studentNation; //学生民族
        this.ruleForm1.birthDate = s.studentBirthday; //学生出生日期
        this.ruleForm1.yuanyin = s.xsylhjrgx; //学生与落户籍人关系
        this.ruleForm1.yuanyin1 = s.xsylhjrgxyy; //学生与落户籍人关系原因
        this.ruleForm1.istwins = s.isTwins; //是否是双胞胎（1：是，2：否）
        this.ruleForm1.tname = s.twinName; //双胞胎姓名
        this.ruleForm1.tidno = s.twinIdcard; //双胞胎身份证号
        this.ruleForm1.isonehk = s.xshfmsfzyghkb; //学生和父母是否在一个户口本（1：是，2：否）
        // this.ruleForm1.yuanyin = s.xshfmbzyghkbyy; //原因
        this.ruleForm1.ishjbd = s.xshjsfzbd; //学生户籍是否在本地（1：是，2：否）
        this.ruleForm1.isfc = s.hasHouse; //有无房产
        this.ruleForm1.isjzz = s.hasResidencePermit; //有无居住证
        this.ruleForm1.yesdate = s.residencePermitLifespan.split(","); //居住证有效期
        this.ruleForm1.stardate =
          this.ruleForm1.yesdate.length > 0 ? this.ruleForm1.yesdate[0] : ""; //居住证有效期开始时间
        this.ruleForm1.enddate =
          this.ruleForm1.yesdate.length > 1 ? this.ruleForm1.yesdate[1] : ""; //居住证有效期结束时间
        this.ruleForm1.jzaddress = s.residencePermitAddress; //居住证上现居住地址
        this.ruleForm1.hjpcs = s.studentDomicilePolice; //学生户籍地派出所
        this.ruleForm1.hjszd = s.domicileAddress; //户籍详细地址
        this.ruleForm1.detailedAddress = s.nowAddress; //现居住详细地址
        this.ruleForm1.special = s.tsyf; //特殊优抚
        this.ruleForm1.ggyuanyin = s.tsyfReason; //特殊优抚说明原因
        this.ruleForm1.geigeiname = s.ggjjname; //哥哥/姐姐姓名
        this.ruleForm1.geigeiidno = s.ggjjidcard; //哥哥/姐姐身份证号
        this.ruleForm1.ggschool = s.ggjjschool; //哥哥/姐姐学校
        this.ruleForm1.ggclass = s.ggjjgrade; //哥哥/姐姐年级
        this.ruleForm1.isgghkb = s.sfyggjjzyghkb; //是否和哥哥姐姐在同一个户口本
        this.ruleForm1.firstGuardianName = s.guardionOneName; //监护人（一）姓名
        this.ruleForm1.firstGuardianRelationship = s.guardionOneRelation; //监护人（一）关系
        this.ruleForm1.firstGuardianIdcardType = s.guardionOneDocumentType; //监护人（一）证件类型
        this.ruleForm1.firstGuardianIdcard = s.guardionOneDocumentNumber; //监护人（一）证件号码
        this.ruleForm1.firstGuardianPhone = s.guardionOneDocumentPhone; //监护人（一）联系电话
        this.ruleForm1.secondGuardianName = s.guardionTwoName; //监护人（二）姓名
        this.ruleForm1.secondGuardianRelationship = s.guardionTwoRelation; //监护人（二）关系
        this.ruleForm1.secondGuardianIdcardType = s.guardionTwoDocumentType; //监护人（二）证件类型
        this.ruleForm1.secondGuardianIdcard = s.guardionTwoDocumentNumber; //监护人（二）证件号码
        this.ruleForm1.secondGuardianPhone = s.guardionTwoDocumentPhone; //监护人（二）联系电话
        // sessionStorage.setItem("from1", JSON.stringify(this.ruleForm1));
        // sessionStorage.setItem("oneid", JSON.stringify(res.data.id));
        if (this.ruleForm1.isfc == "0") {
          this.tlist = this.tlist1;
        } else {
          this.tlist = this.tlist2;
        }
        this.relationships =
          this.ruleForm1.gender == "0"
            ? this.relationships0
            : this.relationships1;
        this.setsession();
      } else {
        this.$toast("查询失败," + res.msg);
      }
    },

    //根据监护人身份证判断性别
    getInfo1(idCard, s) {
      let sex = null;
      let gender = null;
      const myDate = new Date();
      const month = myDate.getMonth() + 1;
      const day = myDate.getDate();
      let age = 0;
      if (idCard.length === 18) {
        age = myDate.getFullYear() - idCard.substring(6, 10) - 1;
        sex = idCard.substring(16, 17);
        if (
          idCard.substring(10, 12) < month ||
          (idCard.substring(10, 12) === month &&
            idCard.substring(12, 14) <= day)
        ) {
          age++;
        }
      }
      if (idCard.length === 15) {
        age = myDate.getFullYear() - idCard.substring(6, 8) - 1901;
        sex = idCard.substring(13, 14);
        if (
          idCard.substring(8, 10) < month ||
          (idCard.substring(8, 10) === month && idCard.substring(10, 12) <= day)
        ) {
          age++;
        }
      }
      if (sex % 2 === 0) {
        sex = 2;
      } // 性别代码 1代表男，2代表女，暂时不涉及其他类型性别
      else {
        sex = 1;
      }
      console.log("age", age);
      console.log("sex", sex);
      // sex === 0 ? sex === '男' : sex === '女'
      if (sex === 2) {
        gender = "1";
      } else {
        gender = "0";
      }
      const reg =
        /^(([1-9][0-9]{5}(19|20)[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}([0-9]|X|x))|([1-9][0-9]{5}[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}))$/;
      if (reg.test(idCard)) {
        if (s != 1) {
          this.ruleForm3.relationship = "";
          this.ruleForm3.relationshipid = "";
        }
        console.log(this.ruleForm1.gender);
        if (this.ruleForm1.gender == "男") {
          this.relationships =
            gender == "0" ? this.relationships2 : this.relationships3;
        } else {
          this.relationships =
            gender == "0" ? this.relationships4 : this.relationships5;
        }
        if (this.ruleForm1.isfc == "2") {
          // this.relationships = this.relationships.filter(
          //   (item) => item.value !== "6"
          // );
          this.relationships = [{ label: "其他", value: "5" }];
        }
      }
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
  <style lang="less" scoped>
/*@import url(); 引入公共css类*/
.red {
  color: red;
  font-size: 0.48rem;
  text-decoration: underline;
  margin-left: 0.4rem;
  margin-top: 0.4rem;
  display: flex;
  align-items: center;
}
.cen {
  width: 100%;
}
.navigation {
  width: 90%;
  height: 1.5rem;
  margin: 1.5rem auto;
  margin-bottom: 2.2rem;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.navigation p {
  width: 1.2rem;
  height: 0.04rem;
  background: #b2dcd8;
  position: relative;
  border: 0.04rem dashed #fff;
  top: -0.2rem;
}
.navigation .dddiv {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 2.4rem;
  border: 0.04rem dashed #0f9386;
  display: flex;
  align-items: center;
  justify-content: center;
}
.navigation .dd {
  width: 1.2rem;
  height: 1.2rem;
  text-align: center;
  line-height: 1.2rem;
  background: #b2dcd8;
  border-radius: 0.6rem;
  font-size: 0.52rem;
  color: #fff;
  border: 0.04rem solid #fff;
  position: relative;
}
.navigation .dd span {
  display: block;
  width: 2rem;
  height: auto;
  position: absolute;
  top: 1.5rem;
  left: -0.4rem;
  font-family: PingFangSC-Regular;
  font-size: 0.48rem;
  color: #ccc;
  letter-spacing: 0.006rem;
}
.navigation .li_special {
  background: #0f9386;
}
.navigation .li_special span {
  color: #000;
}
.btn {
  width: 4.8rem;
  background: #0f9386;
  color: #fff;
  margin-left: 1rem;
  border-radius: 0.2rem;
}
.duan {
  width: 2rem;
  border: none;
}
.tupian {
  display: flex;
  flex-direction: column;
  height: 5rem;
}
/deep/.van-field__label {
  width: 6rem;
  height: 1rem;
}
/deep/.van-field__control--custom {
  margin-top: 0.2rem;
}
.fcbh {
  font-size: 0.48rem;
  /deep/.van-field__label {
    width: 3rem;
  }
}
.van-cell {
  font-size: 0.48rem;
}
.bgdiv {
  height: 0.4rem;
}
/deep/.van-radio__icon--checked .van-icon {
  color: #0f9386;
  background-color: #fff;
  border-color: #0f9386;
  width: 0.8rem;
  height: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  // padding-bottom: 0.04rem;
}
/deep/.van-icon-success:before {
  content: "●" !important;
  width: 0.8rem;
  height: 0.8rem;
  line-height: 0.8rem;
}
/deep/.van-radio__icon {
  width: 0.8rem;
  height: 0.8rem;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
.imgts {
  position: absolute;
  color: red;
  top: -1rem;
  left: 3rem;
  font-size: 0.48rem;
}
/deep/.van-uploader__preview-image {
  width: 3.2rem;
  height: 3.2rem;
}
/deep/.van-uploader__upload {
  width: 3.2rem;
  height: 3.2rem;
}
/deep/.van-field__control--custom {
  align-items: flex-start;
}
/deep/.van-field__error-message {
  text-align: right;
}
/deep/.van-calendar__footer {
  margin-bottom: 2rem !important;
}
</style>